import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';

import CommonImageUploadDropComponent from 'webapp/components/common/image-upload/drop';

import type BlockRenderer from 'webapp/models-custom/block-renderer';
import type BlockSetup from 'webapp/models-custom/block-setup';
import type BlockState from 'webapp/models-custom/block-state';
import type VisualizationImage from 'webapp/models-custom/visualization/image';

interface Args {
	blockState: BlockState;
	blockRenderer: BlockRenderer;
	canEdit: boolean;
	isUnselectable: boolean;
	theme: string;
}

export default class BlockContentImageComponent extends Component<Args> {
	get block() {
		return this.args.blockState.block;
	}

	get blockSetup(): BlockSetup {
		return this.block.blockSetup;
	}

	get visualization(): VisualizationImage {
		return this.blockSetup.visualization as VisualizationImage;
	}

	get showExternalUrl(): boolean {
		return this.args.isUnselectable && !!this.visualization.shownUrl;
	}

	get isViewImageMode() {
		return this.args.isUnselectable || !!this.visualization.shownImage;
	}

	@action
	onImageAdd(image: string) {
		this.visualization.openImageEdit(image);
	}

	@action
	editImage(): void {
		// editing current image
		this.visualization.openImageEdit('', this.block.imageOriginalUrl, this.block.imageCrop);
	}
	<template>
		<div class="block-content__main">

			{{#if this.isViewImageMode}}

				{{#if this.visualization.shownImage}}
					{{#if this.showExternalUrl}}
						<a href={{this.visualization.shownUrl}} target="_blank">
							<img src={{this.visualization.shownImage}} width="100%" alt />
						</a>
					{{else}}
						<img src={{this.visualization.shownImage}} width="100%" alt />
					{{/if}}

					{{#if @canEdit}}
						<a role="button" class="edit" {{on "click" this.editImage}}>Edit image</a>
					{{/if}}
				{{/if}}

			{{else}}
				<CommonImageUploadDropComponent @onImageAdd={{this.onImageAdd}} @theme={{@theme}} />
			{{/if}}

		</div>
	</template>
}
